import React, { Fragment } from "react";

import { Form, Typography } from "antd";

import { formatPrice } from "helperFunctions";

import { StyledDescriptions } from "../../_common/styles";

interface Props {
  name: string[];
  currency: string;
}

export const Preview: React.FC<Props> = ({ name, currency }) => {
  return (
    <Form.Item noStyle shouldUpdate>
      {({ getFieldValue }) => {
        const value = getFieldValue(name);

        return (
          <Fragment>
            <StyledDescriptions bordered column={2} title="Per quantity per month" layout="vertical">
              {/* Pallet Section  */}
              <StyledDescriptions.Item style={{ width: "20%" }}>Pallets</StyledDescriptions.Item>
              <StyledDescriptions.Item>
                <Typography.Text>
                  {value?.pallet ? `${formatPrice(value?.pallet)} ${currency}` : "Not Defined"}
                </Typography.Text>
              </StyledDescriptions.Item>

              {/* Shelf Section  */}
              <StyledDescriptions.Item style={{ width: "20%" }}>Shelves</StyledDescriptions.Item>
              <StyledDescriptions.Item>
                <Typography.Text>
                  {value?.shelf ? `${formatPrice(value?.shelf || 0)} ${currency}` : "Not Defined"}
                </Typography.Text>
              </StyledDescriptions.Item>

              {/* Bin Section  */}
              <StyledDescriptions.Item style={{ width: "20%" }}>Bins</StyledDescriptions.Item>
              <StyledDescriptions.Item>
                <Typography.Text>
                  {value?.bin ? `${formatPrice(value?.bin || 0)} ${currency}` : "Not Defined"}
                </Typography.Text>
              </StyledDescriptions.Item>

              {/* Half-Bin Section  */}
              <StyledDescriptions.Item style={{ width: "20%" }}>Half Bins</StyledDescriptions.Item>
              <StyledDescriptions.Item>
                <Typography.Text>
                  {value?.halfBin ? `${formatPrice(value?.halfBin || 0)} ${currency}` : "Not Defined"}
                </Typography.Text>
              </StyledDescriptions.Item>
            </StyledDescriptions>
          </Fragment>
        );
      }}
    </Form.Item>
  );
};
